import React from 'react';

const Timeline = () => {
  return <div>Timeline Page</div>;
};

export default Timeline;
